module.exports = __webpack_public_path__ + "static/media/equipment.d7013882.svg";